export default __webpack_public_path__ + "static/cli_staisabel-8f46d63a1764fa7e961e41b59a7d4686.png";